import PropTypes from 'prop-types';

const propType = {
  code: PropTypes.string,
  name: PropTypes.string,
  description: PropTypes.string,
  countryCode: PropTypes.string,
  emoji: PropTypes.string,
  isSubjectToVAT: PropTypes.bool,
};

const defaultProp = {
  code: '',
  name: '',
  description: '',
  countryCode: '',
  emoji: '',
  isSubjectToVAT: true,
};

export default { propType, defaultProp };
